export const defaultHomepageSearch = 'DEFAULT_HOMEPAGE_SEARCH';
